import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import styles from './VerificationOtpModal.module.css'
import '../../../assets/css/modal.css'
import { baseUrl, dataContext, portal } from '../../../App';
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useSearchParams } from 'react-router-dom';
import xImg from './assets/x.png'
import otpIcon from './assets/otp_icon.png'
const VerificationOtpModal = ({ showVerificationOtpModal, setShowVerificationOtpModal, activeBottom, setShowPaymentLoadingModal }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  const [otpCode, setOtpCode] = useState("");
  const [showErrorOutline, setShowErrorOutline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isOtpOkay, setIsOtpOkay] = useState(false);
  const [errorMessage, setErrorMessage] = useState(``);
  const [subscriptionService, setSubscriptionService] = useState(sessionStorage.getItem('subscriptionServiceType'));
  const [searchParams, setSearchParams] = useSearchParams();
  // Add resend timer state
  const [resendTimer, setResendTimer] = useState(299); // 5 minutes in seconds

  // Timer effect
  useEffect(() => {
    let timer;
    if (showVerificationOtpModal && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev > 0 ? prev - 1 : 0);
      }, 1000);
    }
    // If timer reaches 0, close the modal
    if (showVerificationOtpModal && resendTimer === 0) {
      setShowVerificationOtpModal(false);
      sessionStorage.removeItem("subscriptionServiceType");
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [showVerificationOtpModal, resendTimer, setShowVerificationOtpModal]);

  // Reset timer when modal is opened
  let verificationOtpToken = sessionStorage.getItem('otpToken')
  useEffect(() => {
    if (showVerificationOtpModal) {
      setResendTimer(299);
    }
  }, [showVerificationOtpModal]);
  const config = {
    headers: { Authorization: `Token ${verificationOtpToken}` },
  };
  function hideModalOperation() {
    setShowError(false);
    setErrorMessage('');
    setShowVerificationOtpModal(false);
  }
  function checkOtp() {
    var otpPattern = /^\d{6}$/;
    if (otpCode.match(otpPattern)) {
      // console.log(otpCode, 'true')
      return true;
    } else {
      // console.log(otpCode, 'false')
      return false;
    }
  }
  function submitOperation() {
    axios
      .post(
        `${baseUrl}/api/otp/verify/`,
        { otp: otpCode, portal: portal },
        config
      )
      .then((response) => {
        console.log(response?.data)
        if (response?.data?.error) {
          setShowError(true);
          setErrorMessage(response?.data?.resultParam?.resultDescription)
          return;
        }
        setShowVerificationOtpModal(false);
        localStorage.setItem("AuthToken", verificationOtpToken);
        setToken(verificationOtpToken);

        sessionStorage.removeItem("subscriptionServiceType")
      }).catch(error => {
        console.log(error);
        if (error?.response?.data?.error) {
          setShowError(true);
          setErrorMessage(error?.response?.data?.error)
        }
      })
  }




  return (
    <>
      <Modal show={showVerificationOtpModal} centered dialogClassName={styles.VerificationOtpModalDialog} contentClassName={styles.VerificationOtpModalContent} onHide={hideModalOperation} backdrop="static">
        <img src={xImg} alt="logo" className={styles.xImg} onClick={hideModalOperation} />
        <Modal.Body className={styles.VerificationOtpModalBody}>
          <img src={otpIcon} alt="logo" className={styles.otpIcon} />
          <div className={styles.infoContainer}>
            <span className={styles.infoText}>OTP দিন</span>
            
            <span style={{fontSize:'14px'}}>মোবাইলে পাঠানো ওটিপি দিন, মেয়াদ ৫ মিনিট।</span>
            <div className={styles.inputContainer}>
              <span>OTP Timer: {Math.floor(resendTimer / 60)}:{(resendTimer % 60).toString().padStart(2, '0')}</span>
              <span className={`${styles.inputSpan}`}>
                <input
                  type="text" 
                  maxLength={6}
                  onKeyUp={(e) => {
                    // Only allow numbers and limit to 6 digits
                    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                    e.target.value = value;
                    setOtpCode(value);
                    setIsOtpOkay(checkOtp());
                  }}
                  onChange={(e) => {
                    // Only allow numbers and limit to 6 digits
                    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                    e.target.value = value;
                    setOtpCode(value);
                    setIsOtpOkay(checkOtp());
                  }}
                  onKeyDown={(e) => e.key === 'Enter' && submitOperation()}
                  id="otpCode"
                  name="otpCode"
                  placeholder="OTP নম্বর দিন"
                  className={styles.inputFieldOtp}
                />{" "}
              </span>
              {showError && <div style={{ color: "#ff0000", textAlign: 'center', fontWeight: 600 }}>* {errorMessage}</div>}
              <button
                type="button"
                className={`btn ${styles.numberSubmit}`}
                onClick={submitOperation}
                disabled={!isOtpOkay}
                style={{ backgroundColor: !isOtpOkay ? "#757575" : "#FB005D" }}
              >
                {isLoading ? (
                  <Spinner animation="border" variant="light" size="sm" />
                ) : (
                  "সাবমিট করুন"
                )}
              </button>
            </div>
          </div>

          {/* End */}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default VerificationOtpModal